import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withStyles, Grid } from '@material-ui/core';
import { FHEContainerForm, FHEItemText, FHEMiniFormEditButton, FHEDivider, FHETextField, FHEReactSelect } from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import memoizeOne from 'memoize-one';
import { updateProductModule, updateProductModuleLabel } from '../../../../../../data/Products/actions';

class SDM17SPG extends PureComponent {
    static propTypes = {
        enumProductModulesTypes: PropTypes.array.isRequired,
        theme: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        planningMode: PropTypes.string,
        maxAutonomy: PropTypes.number,
        idleTime: PropTypes.number,
        power: PropTypes.number,
        moduleType: PropTypes.string,
        productType: PropTypes.string,
        threshold: PropTypes.number,
        code: PropTypes.string,
        lineType: PropTypes.string,
        planningSynched: PropTypes.number,
        value: PropTypes.string,
        idlePower: PropTypes.number,
        reversePolarity: PropTypes.number,
        loadTime: PropTypes.number,
        label: PropTypes.string,
        planningType: PropTypes.string,
        fheCenter_mac: PropTypes.string,
        favorite: PropTypes.number,
        updateProductModule: PropTypes.func.isRequired,
        updateProductModuleLabel: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        type: PropTypes.string
    };

    static defaultProps = {
        planningMode: null,
        maxAutonomy: null,
        idleTime: null,
        power: null,
        fheCenter_mac: null,
        moduleType: null,
        productType: null,
        threshold: null,
        code: null,
        lineType: null,
        planningSynched: null,
        value: null,
        idlePower: null,
        reversePolarity: null,
        loadTime: null,
        label: null,
        planningType: null,
        favorite: null,
        type: null
    };

    constructor(props) {
        super(props);
        this.state = {
            labelDisabled: true,
            moduleTypeDisabled: true,
            textInput_error: {},
            sendLabelLoading: false,
            sendModuleTypeLoading: false,
            moduleType: null,
            label: null
        };

    }

    static getDerivedStateFromProps(props, state) {
        const { labelDisabled, moduleTypeDisabled, sendLabelLoading } = state;
        const { moduleType, label } = props;
        let res = {};

        if (labelDisabled && !sendLabelLoading && label !== state.label) {
            res = {
                label
            };
        }

        if (moduleTypeDisabled && moduleType !== state.moduleType) {
            Object.assign(res, {
                moduleType
            });
        }

        if (Object.keys(res).length > 0) return res;
        return null;
    }

    handleEditLabel = () => {
        const { labelDisabled } = this.state;

        this.setState({
            labelDisabled: !labelDisabled
        });
    };
    handleEditModuleType = () => {
        const { moduleTypeDisabled } = this.state;
        this.setState({
            moduleTypeDisabled: !moduleTypeDisabled
        });
    };

    handleFormError = (fields, message) => {
        let res = {};
        Object.keys(fields).map(field => {
            fields[field].forEach(error => {
                if (res[field] === undefined) res[field] = [];

                res[field].push(
                    <p key={error} className="mb-1">
                        {Translator.translate(`general.fields.error.${error}`)}
                    </p>
                );
            });
        });

        this.setState({
            textInput_error: res
        });

        return Toastr.error(message);
    };

    handleChangeLabelWithVerification = event => {
        const { textInput_error, label } = this.state;
        let targetValue = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

        const fieldLengthRules = {
            label: 255
        };

        let newTextInput_error = this.removeKey(textInput_error, event.target.name);

        let maxLength = fieldLengthRules[event.target.name];
        if (maxLength && targetValue.length > maxLength) targetValue = label;
        if (targetValue === '') targetValue = null;

        this.setState({
            [event.target.name]: targetValue,
            textInput_error: newTextInput_error
        });
    };

    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    };

    isEmpty = value => {
        return value === null || /^\s*$/.test(value);
    };

    loadInputs = () => {
        const { moduleType, label } = this.props;
        this.setState({
            labelDisabled: true,
            moduleTypeDisabled: true,
            textInput_error: {},
            sendLabelLoading: false,
            sendModuleTypeLoading: false,
            moduleType,
            label
        });
    };

    removeKey = (myObj, deleteKey) => {
        return Object.assign(
            {},
            ...Object.entries(myObj)
                .filter(([k]) => k !== deleteKey)
                .map(([k, v]) => ({ [k]: v }))
        );
    };

    confirmEditLabel = () => {
        const { label } = this.state;
        const { updateProductModuleLabel, match, code, type, fheCenter_mac, history } = this.props;

        this.setState({
            sendLabelLoading: true,
            labelDisabled: true
        });

        return updateProductModuleLabel(fheCenter_mac, match.params.productIdentifier, match.params.productType, type, code, label)
            .then(() => {
                Toastr.success(Translator.translate(`generic.products.actions.editProductModuleSuccess`));
                this.loadInputs();
            })
            .catch(error => {
                this.setState({
                    sendLabelLoading: false,
                    labelDisabled: false
                });
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${error.message ? error.message : error}`, 'socket.error.defaultError'),
                    Translator.translate(`generic.products.actions.editProductModuleError`)
                );
                if (error.validation && error.validation.errors) {
                    return this.handleFormError(error.validation.errors, Translator.translate(`generic.products.actions.editProductModuleError`));
                }
            });
    };

    confirmEditModuleType = () => {
        const { moduleType } = this.state;
        const { updateProductModule, match, code, type, lineType, history } = this.props;

        this.setState({
            sendModuleTypeLoading: true,
            moduleTypeDisabled: true
        });

        return updateProductModule(
            match.params.homeId,
            match.params.productIdentifier,
            match.params.productType,
            code,
            { moduleType },
            type,
            lineType
        )
            .then(() => {
                Toastr.success(Translator.translate(`generic.products.actions.editProductModuleSuccess`));
                this.loadInputs();
            })
            .catch(error => {
                this.setState({
                    sendModuleTypeLoading: false,
                    moduleTypeDisabled: false
                });
                Toastr.error(Translator.translate(`generic.products.actions.editProductModuleError`));
                if (error.validation && error.validation.errors) {
                    return this.handleFormError(error.validation.errors, Translator.translate(`generic.products.actions.editProductModuleError`));
                }
            });
    };

    getSelectedType = memoizeOne(type => {
        const { enumProductModulesTypes } = this.props;
        return enumProductModulesTypes.find(x => x.value === type);
    });

    handleReactSelect = event => {
        this.setState({
            moduleType: event.value
        });
    };

    render() {
        const {
            enumProductModulesTypes,
            planningMode,
            maxAutonomy,
            idleTime,
            power,
            productType,
            threshold,
            code,
            lineType,
            planningSynched,
            value,
            idlePower,
            reversePolarity,
            loadTime,
            planningType,
            favorite,
            theme,
            profile,
            history,
            type
        } = this.props;
        const { labelDisabled, moduleTypeDisabled, textInput_error, sendLabelLoading, sendModuleTypeLoading, label, moduleType } = this.state;
        const userRightUpdate =
            profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes(`productModules_${type}_${lineType}_update`);
        return (
            <FHEContainerForm>
                <Grid container spacing={3}>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEMiniFormEditButton
                            handleEdit={this.handleEditLabel}
                            confirmEdit={this.confirmEditLabel}
                            sendLoading={sendLabelLoading}
                            formDisabled={labelDisabled}
                            hasRightToEdit={userRightUpdate}
                        >
                            <FHETextField
                                disabled={labelDisabled}
                                id="label"
                                value={!label || label === null ? '' : label}
                                error={textInput_error.label}
                                label={Translator.translate('general.table.column.label')}
                                name="label"
                                onChange={this.handleChangeLabelWithVerification}
                            />
                        </FHEMiniFormEditButton>
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEMiniFormEditButton
                            handleEdit={this.handleEditModuleType}
                            confirmEdit={this.confirmEditModuleType}
                            sendLoading={sendModuleTypeLoading}
                            formDisabled={moduleTypeDisabled}
                            hasRightToEdit={userRightUpdate}
                        >
                            <FHEReactSelect
                                name="moduleType"
                                label={Translator.translate('general.table.column.moduleType')}
                                disabled={moduleTypeDisabled}
                                onChange={this.handleReactSelect}
                                value={this.getSelectedType(moduleType)}
                                choices={enumProductModulesTypes}
                            />
                        </FHEMiniFormEditButton>
                    </Grid>
                </Grid>
                <FHEDivider color={theme.palette.colors.grey100} />
                <Grid container spacing={3}>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.productType')}
                            itemContent={Translator.translate(`general.productModules.${productType}`)}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.lineType')}
                            itemContent={Translator.translate(`general.productModules.${lineType}`)}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.reversePolarity')}
                            itemContent={Translator.translate(`general.productModules.${reversePolarity}`)}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.code')} itemContent={code} />
                    </Grid>
                </Grid>
                <FHEDivider color={theme.palette.colors.grey100} />
                <Grid container spacing={3}>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.planningMode')}
                            itemContent={Translator.translate(`general.productModules.${planningMode}`)}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.planningSynched')}
                            itemContent={Translator.translate(`general.productModules.${planningSynched}`)}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.planningType')}
                            itemContent={Translator.translate(`general.productModules.${planningType}`)}
                        />
                    </Grid>
                </Grid>
                <FHEDivider color={theme.palette.colors.grey100} />
                <Grid container spacing={3}>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.maxAutonomy')} itemContent={maxAutonomy} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.idleTime')} itemContent={idleTime} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.power')} itemContent={power} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.threshold')} itemContent={threshold} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.value')} itemContent={value} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.idlePower')} itemContent={idlePower} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.loadTime')} itemContent={loadTime} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.favorite')}
                            itemContent={Translator.translate(`general.productModules.${favorite}`)}
                        />
                    </Grid>
                </Grid>
            </FHEContainerForm>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const productKey = props.productKey;
    const product = state.environments[history.environment].data.Products.getIn(['list', productKey], new Map());
    let productModule = state.environments[history.environment].data.Products.getIn(['list', productKey, 'productModules'], new Map());

    if (productModule.size > 0) {
        productModule = productModule.first();
    }

    let fheCenter_mac = null;
    state.environments[history.environment].data.Boxes.get('list').map((box, macAddress) => {
        if (box.get('homeId') === productModule.get('homeId')) fheCenter_mac = macAddress;
    });
    const enums = state.environments[history.environment].enums;
    return {
        enumProductModulesTypes: enums.productModulesTypes || [],
        profile: state.data.user,
        type: product.get('type'),
        planningMode: productModule.get('planningMode'),
        maxAutonomy: productModule.get('maxAutonomy'),
        idleTime: productModule.get('idleTime'),
        power: productModule.get('power'),
        imageName: productModule.get('imageName'),
        moduleType: productModule.get('moduleType'),
        productType: productModule.get('productType'),
        threshold: productModule.get('threshold'),
        code: productModule.get('code'),
        lineType: productModule.get('lineType'),
        planningSynched: productModule.get('planningSynched'),
        value: productModule.get('value'),
        idlePower: productModule.get('idlePower'),
        reversePolarity: productModule.get('reversePolarity'),
        loadTime: productModule.get('loadTime'),
        label: productModule.get('label'),
        planningType: productModule.get('planningType'),
        productIdentifier: productModule.get('productIdentifier'),
        favorite: productModule.get('favorite'),
        fheCenter_mac
    };
}

const styles = () => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    }
});
export default withRouter(
    renderEnvComponent(
        'scenes/Products/components/Product/Fhe/SDM17SPG/index',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(
                    tools.mergePropsToAction(ownProps.history.environment, {
                        updateProductModule,
                        updateProductModuleLabel
                    }),
                    dispatch
                )
        )(withStyles(styles, { withTheme: true })(SDM17SPG))
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/Product/Fhe/SDM17SPG/index.js